import Image from './Image'
import {login} from '../actions/login';
import auth from '../utils/auth';
import classes from './Login.module.css';
import {useState} from "preact/hooks";

export default function Login({setIsModalOpen, isModalOpen}) {
    const [error, setError] = useState('');
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    async function onFinish(e) {
        e.preventDefault();
        const account = e.target?.account?.value;
        const password = e.target?.password?.value;
        let message = '';
        if (!account) {
            message = '请输入用户名';
        }
        if (!password) {
            message = '请输入密码';
        }
        if (message) {
            setError(message);
            setTimeout(() => {
                setError('');
            }, 3000)
            return;
        }
        return login({
            account,
            password
        }).then(result => {
            if (result.ret == 0) {
                auth(result.data);
            } else {
                setError(result?.msg);
                setTimeout(() => {
                    setError('');
                }, 3000)
            }
        })
    }

    return (


        <div className={classes.rootDialog}>
            <div className={classes.mask} onClick={handleCancel}></div>
            <div className={classes.modal}>
                <div style={{
                    width: 219,
                    height: 219,
                    color: '#fff',
                    backgroundColor: '#f7f7f7',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Image
                        width={100} height={40}
                        src={`${process.env.PREACT_APP_STATIC_URL}/jeean-logo/jeean-cloud-logo-gov.svg`}
                        alt=""
                    />
                </div>

                <form className={classes.form} autoComplete="off" onSubmit={onFinish}>
                    <div>
                        <input placeholder="请输入用户名" name="account" type="text"
                               className={classes.input}/>
                        <input placeholder="请输入密码" name="password" type="password"
                               className={classes.password}/>
                        {
                            error && <p className={classes.error}>{error}</p>
                        }
                    </div>
                    <div>
                        <div  className={classes.link}>
                            <a
                                target="_blank"
                                href="/Register/findPwd"
                                type="link">
                                忘记密码
                            </a>
                        </div>
                        <button type="submit" className={classes.button}>登录</button>
                    </div>
                </form>
            </div>
        </div>
    )
};
